import React, {useEffect} from 'react'
import {Image, Rect, Transformer} from "react-konva";
import useImage from "use-image";

const TemplateImageShape = ({
                                templateImage,
                                settings,
                                stageHeight,
                                stageWidth,
                            }) => {
    const [image] = useImage(templateImage.src, 'anonymous');
    const shapeRef = React.useRef();

    /*useEffect(() => {
        console.log('templateImage', {templateImage, stageHeight, stageWidth, settings});
        console.log('fillPatternScaleX - width', stageWidth / templateImage.width);
        console.log('stageWidth', stageWidth);
        console.log('stageHeight', stageHeight);
        console.log('templateImage.width', templateImage.width);
        console.log('templateImage.height', templateImage.height);
        /!* console.log('fillPatternScaleY - width', stageWidth / templateImage.width);
         console.log('fillPatternScaleX - height', stageHeight / templateImage.height);
         console.log('fillPatternScaleY - height', stageHeight / templateImage.height);*!/
    }, [templateImage?.src]);*/

    return (
        <>
            {image &&
                <Rect
                    name={'template-image'}
                    ref={shapeRef}
                    x={0}
                    y={0}
                    width={stageWidth}
                    height={stageHeight}
                    fillPatternImage={image}
                    fillPatternRepeat={'no-repeat'}
                    fillPatternRotation={templateImage?.fillPatternRotation}
                    fillPatternOffsetX={templateImage?.fillPatternOffsetX}
                    fillPatternOffsetY={templateImage?.fillPatternOffsetY}
                    fillPatternScaleX={stageWidth / templateImage.width}
                    fillPatternScaleY={stageWidth / templateImage.width}
                    listening={false}/>
            }
        </>
    )
}

export default TemplateImageShape
